// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

//cookies

setTimeout(function(){
  $('#cookies__block').addClass('active');
}, 2000);


setTimeout(function(){
 if ($("#cookies__block").length > 0){
    $('#cookies__txt').focus();

        $(document).keyup(function (e) {
        if (e.keyCode === 13)
            $('#cookies__close').click();
    });

};

}, 2100);



 $('#cookies__accept').click(function() {
  $('#cookies__block').removeClass('active');
  document.cookie = "cookieAccept=yes; max-age=1209600; path=/";
      
  });

  $('#cookies__close').click(function() {
  $('#cookies__block').removeClass('active');
  });
  
 var cookies =  document.cookie;
if (cookies.includes('cookieAccept=yes')){
  $('#cookies__block').css('display','none').removeClass('active');
}

var cookies =  document.cookie;
if (cookies.includes('_ga_')){
  $('#cookies__block').css('display','none').removeClass('active');
}


  // function consentGranted() {
  //   gtag('consent', 'update', {
  //     'ad_storage': 'granted'
  //   });
  // }


//wcag
$('#wcag__1').on('click', function() {
	$('body').removeClass('wcag__size2').removeClass('wcag__size3');
 });

$('#wcag__2').on('click', function() {
	$('body').addClass('wcag__size2').removeClass('wcag__size3');
 });

$('#wcag__3').on('click', function() {
	$('body').removeClass('wcag__size2').addClass('wcag__size3');
 });


$('#wcag__contrast').on('click',function(){
	$('body').toggleClass('wcag__contrast');
});

$('#print-this').on('click',function(){
  $('body').toggleClass('printable');
  $('#print').show();
  $('#print-back').show();
  $(this).hide();
});

$('#print-back').on('click',function(){
  $('body').toggleClass('printable');
  $('#print').hide();
  $('#print-this').show();
  $(this).hide();
});



//titles 


  // $('#tabs ul.ui-tabs-custom li a').each(function(){
  // 	$(this).attr('title', 'Rozwiń zakładkę')
  // });



    // $("#toggle-search-mobile").click(function () {
    //     var val = $(this).attr("title");
    //     if (val == 'Pokaż wyszukiwarkę') {
    //         $(this).attr("title", "Ukryj wyszukiwarkę");
    //     } else {
    //         $(this).attr("title", "Pokaż wyszukiwarkę");
    //     }

    // });
    


    $('a').each(function() {
    if ( $(this).attr('target') == '_blank'){
    	$(this).attr('title', 'Otwórz stronę w nowej zakładce');
	    }
	});

    $('.menu-item-has-children > a').each(function () {
        $(this).attr('title', 'Rozwiń menu');
    });

    
    $(".menu-item-has-children > a").click(function () {
        var val = $(this).attr("title");
        if (val == 'Rozwiń menu') {
            $(this).attr("title", "Zwiń menu");
        } else {
            $(this).attr("title", "Rozwiń menu");
        }

    });


//     function getEndsWithSelector(names) {
//     return names.map(n => 'a[href$=".'+name+'"]').join();
// }

    $("a[href$='pdf'], a[href$='doc'], a[href$='docx']").attr('target','_blank');
	$("a[href$='pdf']").attr('title','Otwórz plik w nowej karcie');
	$("a[href$='doc'], a[href$='docx']").attr('title','Pobierz plik');



setTimeout(function(){

	    $('a').each(function () {
	        if($(this).attr('title','')){
	            $(this).attr('title', 'Przejdź do strony');
	        }
	    });

}, 1000);



